import {
  VideoError,
  VideoBlockedError,
  VideoLoadingError,
  VideoRatedContentError,
  VideoRatedContentMissingBirthdayError,
  VideoRatedContentMissingPinError,
  VideoRatedContentMissingSetPinError,
} from '@/scripts/store/modules/video/state/errors';
import { VideoOverlay, VideoOverlayType, VideoOverlayPriority } from '../../state/VideoOverlay';

const getOverlayNameWithError = (error: VideoError, name?: string): string => {
  if (name) return name;

  if (error instanceof VideoLoadingError) {
    return 'GenericErrorOverlay';
  }
  if (error instanceof VideoRatedContentMissingBirthdayError) {
    return 'AgeRestrictedNeedBirthdayOverlay';
  }
  if (error instanceof VideoRatedContentMissingPinError) {
    return 'AgePinGateOverlay';
  }
  if (error instanceof VideoRatedContentMissingSetPinError) {
    return 'SetPinOverlay';
  }
  if (error instanceof VideoRatedContentError) {
    return 'AgeRestrictedOverlay';
  }
  if (error instanceof VideoBlockedError) {
    return 'GenericErrorOverlay';
  }

  return 'Unknown';
};

const getPriorityWithError = (error: VideoError, priority?: VideoOverlayPriority): VideoOverlayPriority => {
  if (priority != null) return priority;

  if (error instanceof VideoLoadingError) {
    return VideoOverlayPriority.LoadingError;
  }
  if (error instanceof VideoBlockedError) {
    return VideoOverlayPriority.BlockedError;
  }

  return VideoOverlayPriority.BlockedError;
};

export const createVideoOverlayWithError = (error: VideoError, name?: string, priority?: VideoOverlayPriority): VideoOverlay => ({
  name: getOverlayNameWithError(error, name),
  createdAt: Date.now(),
  type: VideoOverlayType.Error,
  priority: getPriorityWithError(error, priority),
});

interface VideoOverlayErrorPayloadCommon {
  priority?: VideoOverlay['priority'];
  component?: VideoOverlay['component'];
  presentation?: VideoOverlay['presentation'];
}

interface VideoOverlayErrorPayload extends VideoOverlayErrorPayloadCommon {
  name?: string;
  error: Error;
}
export interface VideoOverlayNamedPayload extends VideoOverlayErrorPayloadCommon {
  name: string;
  type?: VideoOverlayType;
}
export type VideoOverlayPayload = VideoOverlayErrorPayload | VideoOverlayNamedPayload;

export const createVideoOverlayWithVideoOverlayPayload = (payload: VideoOverlayPayload): VideoOverlay => {
  if ('error' in payload) {
    return createVideoOverlayWithError(payload.error, payload.name, payload.priority);
  }

  return {
    priority: VideoOverlayPriority.UserInteraction,
    type: VideoOverlayType.Dismissable,
    ...payload,

    createdAt: Date.now(),
  };
};
